module.exports = __webpack_public_path__ + "img/icon_arrow_right.a48c49b3.svg";